<template>
  <abstract-graph :show="!!data">
    <template slot="header"><slot name="header"></slot></template>
    <v-graph :data="data" :layout="layout" :options="options"/>
  </abstract-graph>
</template>

<script>
import AbstractGraph from "./AbstractGraph";
import color from "./color";

export default {
  props: {
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    loadDataFn: {
      type: Function,
      required: true
    },
    annotationValue: {
      type: Number | Array,
      default: null
    },
    annotationTitle: {
      type: String,
      default: ""
    },
    group: {
      type: Boolean,
      default: false
    }
  },

  components: {
    AbstractGraph
  },

  data() {
    return {
      realData: [],
      options: { displayModeBar: false, responsive: true }
    };
  },

  computed: {
    data() {
        return this.realData;
    },

    shapes() {
      if (this.annotationValue == null) {
        return null;
      }
      const values = Array.isArray(this.annotationValue)
        ? this.annotationValue
        : [this.annotationValue];
      return values.map((value, index, arr) => ({
        type: "line",
        xref: "paper",
        yref: "y",
        x0: index / arr.length,
        y0: value,
        x1: (index + 1) / arr.length,
        y1: value,
        line: {
          color: "blue",
          dash: "dot",
          width: 1
        }
      }));
    },

    annotations() {
      if (this.annotationValue == null) {
        return null;
      }
      const values = Array.isArray(this.annotationValue)
        ? this.annotationValue
        : [this.annotationValue];
      return values.map((value, index, arr) => ({
        xref: "paper",
        yref: "y",
        x: index / arr.length,
        xanchor: "left",
        y: value,
        yanchor: "bottom",
        text: [this.annotationTitle, value].filter(d => d).join(" "),
        showarrow: false,
        font: {
          family: "sans serif",
          size: 12,
          color: "blue"
        }
      }));
    },

    layout() {
      return {
        title: this.label,
        legend: {
          orientation: "h",
          x: 0.5,
          xanchor: "center"
        },
        boxmode: this.group ? "group" : "overlay",
        paper_bgcolor: "transparent",
        plot_bgcolor: "transparent",
        colorway: color,
        xaxis: {
          type: "category",
          visible: this.group
        },
        yaxis: {
          gridcolor: "#bfbfbf",
          rangemode: "tozero"
        },
        shapes: this.shapes,
        annotations: this.annotations,
        showTips: true
      };
    }
  },

  created() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.loadDataFn({
        type: this.type
      }).then(data => {
        this.realData = data || [];
      });
    }
  }
};
</script>
